export const getNumber = (value: string) => {
  const res = Number(value);
  return Number.isNaN(res) ? 0 : res;
}

export default {
  getNumber,
}
